import * as S from './styles'

const Hero = () => (
  <S.HeroSection>
    <div className="container">
      <S.HeroTitle>
        As melhores vagas para tecnologia, design e artes visuais.
      </S.HeroTitle>
    </div>
  </S.HeroSection>
)

export default Hero
